module.exports = __webpack_public_path__ + "static/media/leader.0a9571c7.svg";